import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PolygonType } from 'src/app/bo/polygon/tirsPolygone';
import { SiteMapStore } from '../../site-map.store';

@Component({
  selector: 'app-site-map-filter-panel',
  standalone: true,
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SiteMapFilterPanelComponent {
  protected readonly store = inject(SiteMapStore);

  protected readonly polygonOptions = [
    { type: PolygonType.AutomaticFromHoles, label: 'Automatic', icon: 'assets/icon/Polygon.svg' },
    { type: PolygonType.DrillingContour, label: 'Drilled', icon: 'assets/icon/Polygon_drilled.svg' },
    { type: PolygonType.MuckPile, label: 'Muckpile', icon: 'assets/icon/Polygon_muck.svg' },
    { type: PolygonType.DangerZone, label: 'Danger zone', icon: 'assets/icon/Polygon_danger.svg' },
  ];
}
